import React from 'react';


import { Box } from 'ui/box';

import GoalsSidebarItem from 'containers/admin/clients/client/tabs-components/goals-tab/goals-manager/goals-sidebar/goals-sidebar-item/goals-sidebar-item';
import type { Goal } from 'containers/admin/clients/client/tabs-components/goals-tab/types';

export interface GoalSelectArg {
  event: React.MouseEvent<HTMLButtonElement> | null;
  to: string;
  id: string | number;
}

interface GoalsSidebarProps {
  goals?: Goal[];
  handleGoalSelect: (arg: GoalSelectArg) => void;
  selectedGoal: string | number;
  isNew: boolean;
  isEditMode: boolean;
}

const GoalsSidebar = ({
  goals = [],
  handleGoalSelect,
  selectedGoal,
  isNew,
  isEditMode,
}: GoalsSidebarProps): React.JSX.Element => (
  <Box
    sx={{
      width: '300px',
      minWidth: 0,
      flexShrink: 0,
      pr: 2,
      pt: 2,
      borderRightWidth: '1px',
      overflow: 'hidden',
    }}
  >
    {isNew && <GoalsSidebarItem isNew={isNew} />}
    {goals.map((goal) => (
      <GoalsSidebarItem
        key={goal?.id}
        goal={goal}
        handleGoalSelect={handleGoalSelect}
        selectedGoal={selectedGoal}
        disabled={isNew || isEditMode}
      />
    ))}
  </Box>
);

export default GoalsSidebar;
